module.exports = __webpack_public_path__ + "static/5123-0c5633cc055e31140224091933dd4398.jpg";